/**
 * הגדרות טיפוגרפיה לשימוש בכל האפליקציה
 * מבוסס על טווילווינד עם צבעים מוגדרים ב-tailwind.config.js
 */

// טקסט כותרות
export const headingClasses = {
  // כותרת ראשית גדולה - לשימוש בכותרות ראשיות של סקשנים
  hero: "text-3xl md:text-5xl font-medium text-[#f8f5f0] mb-4 text-center max-w-3xl mx-auto whitespace-normal leading-tight",
  
  // כותרת משנית לכרטיסים ואלמנטים משניים
  secondary: "text-xl lg:text-2xl font-semibold mb-3 text-text-white",
  
  // כותרת קטנה
  small: "text-lg font-medium mb-2 text-text-white"
};

// טקסט פסקאות
export const textClasses = {
  // טקסט רגיל
  body: "text-text-gray-light text-sm lg:text-base",
  
  // טקסט קטן
  small: "text-text-gray-lighter text-xs",
  
  // הדגשה
  highlight: "text-accent-yellow font-medium",
  
  // טקסט כפתורים
  button: "font-medium"
};

// לשימוש עבור קונטיינרים וסקשנים
export const sectionClasses = {
  // קונטיינר שחור עם padding מותאם
  darkSection: "w-full py-20 bg-bg-black text-text-white overflow-hidden",
  
  // קונטיינר פנימי מרוכז
  container: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"
};

// סגנונות כרטיסים
export const cardClasses = {
  // כרטיס סטנדרטי עם רקע כהה ומסגרת
  standard: "bg-bg-darker/20 backdrop-blur-sm border border-bg-darker rounded-xl p-6 lg:p-8 hover:border-bg-dark transition-all duration-300"
}; 